(function () {
  'use strict';

  const COLLECTION_HANDLE = 'add-on';
  const MAX_PRODUCTS = 10;
  const CARD_WIDTH = 140;

  // Chaînes traduites (FR/EN) lues depuis les data-attributes du conteneur,
  // rendues côté Liquid via `| t` — ce fichier JS n'a pas accès aux
  // traductions du thème directement, donc elles lui sont passées ainsi.
  // Valeurs ci-dessous = repli si jamais le conteneur n'est pas trouvé.
  var STRINGS = {
    add: 'Ajouter',
    adding: 'Ajout...',
    added: 'Ajouté',
    soldOut: 'Épuisé',
    error: 'Erreur',
    unavailable: 'Indisponible',
    chooseOption: 'Choisir une option'
  };

  function loadStrings() {
    var section = document.getElementById('cart-addon-collection');
    if (!section) return;
    var d = section.dataset;
    if (d.strAdd) STRINGS.add = d.strAdd;
    if (d.strAdding) STRINGS.adding = d.strAdding;
    if (d.strAdded) STRINGS.added = d.strAdded;
    if (d.strSoldOut) STRINGS.soldOut = d.strSoldOut;
    if (d.strError) STRINGS.error = d.strError;
    if (d.strUnavailable) STRINGS.unavailable = d.strUnavailable;
    if (d.strChooseOption) STRINGS.chooseOption = d.strChooseOption;
  }

  function formatMoney(cents) {
    const fmt = (window.theme && window.theme.moneyFormat) ? window.theme.moneyFormat : '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.floor(cents / 100));
  }

  // Après un ajout réussi, le reste du thème (barre de livraison gratuite,
  // popup cadeau Octobre Rose, etc.) ne se met à jour QUE via l'événement
  // "theme:cart:change" dispatché avec le panier frais — ce fichier ne le
  // faisait jamais auparavant, ce qui causait un vrai bug : ajouter un
  // article via "Ajout rapide" ne faisait réagir aucune autre partie du
  // panier (le cadeau Octobre Rose ne se déclenchait pas même si le
  // seuil de 114,99 $ venait d'être atteint par cet ajout). On réplique
  // ici exactement le même fetch + dispatch que layout/theme.liquid.
  function dispatchCartChange(cart) {
    document.dispatchEvent(new CustomEvent('theme:cart:change', {
      detail: { cart: cart },
      bubbles: true
    }));
  }

  function addToCart(variantId, btn) {
    btn.disabled = true;
    btn.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(r => r.json())
      .then(data => {
        // Shopify returns either {id:...} (single item) or {items:[...]} (batch)
        var success = data.id || (data.items && data.items.length > 0);
        if (success) {
          btn.textContent = '✓ ' + STRINGS.added;
          btn.style.background = '#2a7a4b';

          // Refresh cart items via theme AJAX
          fetch((window.theme && window.theme.routes ? window.theme.routes.root_url : '/') + '?section_id=api-cart-items')
            .then(r => r.text())
            .then(html => {
              const fresh = document.createElement('div');
              fresh.innerHTML = html;
              const lineItems = document.querySelector('[data-line-items]');
              const apiContent = fresh.querySelector('[data-api-content]');
              if (lineItems && apiContent) lineItems.innerHTML = apiContent.innerHTML;
            });

          // Update cart count + total, and notify the rest of the theme
          // (shipping bar, gift-with-purchase popup) via theme:cart:change.
          fetch('/cart.js')
            .then(r => r.json())
            .then(cart => {
              document.querySelectorAll('[data-cart-count],[data-header-cart-count]').forEach(el => {
                el.textContent = cart.item_count;
                el.style.display = '';
              });
              // shop.money_format can (and here does) include real markup
              // (e.g. `<span class="money">${{amount}}</span>`) — it must
              // be inserted via innerHTML, not textContent, or the tags
              // show up as literal text in the drawer.
              document.querySelectorAll('[data-cart-final]').forEach(el => {
                el.innerHTML = formatMoney(cart.total_price);
              });
              // Show cart bottom if hidden
              document.querySelectorAll('[data-cart-bottom]').forEach(el => {
                el.classList.remove('cart--hidden');
              });
              dispatchCartChange(cart);
            });

          setTimeout(() => {
            btn.textContent = STRINGS.add;
            btn.style.background = '';
            btn.disabled = false;
          }, 2000);
        } else {
          btn.textContent = data.description || STRINGS.unavailable;
          btn.disabled = false;
          setTimeout(() => { btn.textContent = STRINGS.add; }, 2500);
        }
      })
      .catch(() => {
        btn.textContent = STRINGS.error;
        btn.disabled = false;
        setTimeout(() => { btn.textContent = STRINGS.add; }, 2000);
      });
  }

  function buildCard(product) {
    // Use first image
    let imageUrl = '';
    if (product.images && product.images.length > 0) {
      imageUrl = product.images[0].src
        ? product.images[0].src.split('?')[0] + '?width=280'
        : '';
    }

    const variants = product.variants || [];
    const hasMultipleVariants = variants.length > 1;
    const defaultVariant = variants[0] || null;
    // Collections API returns prices as dollar strings ("12.99"), convert to cents for formatMoney
    const price = defaultVariant ? Math.round(parseFloat(defaultVariant.price) * 100) : 0;
    const compareAt = defaultVariant && defaultVariant.compare_at_price
      ? Math.round(parseFloat(defaultVariant.compare_at_price) * 100)
      : null;

    const li = document.createElement('li');
    li.className = 'cart-rv__card';

    let variantHtml = '';
    if (hasMultipleVariants) {
      const options = variants.map(v =>
        `<option value="${v.id}"${!v.available ? ' disabled' : ''}>${v.title}${!v.available ? ' – ' + STRINGS.soldOut : ''}</option>`
      ).join('');
      variantHtml = `<select class="cart-rv__select" aria-label="${STRINGS.chooseOption}">${options}</select>`;
    }

    // Find first available variant for default button state
    const firstAvailable = variants.find(v => v.available) || defaultVariant;
    const isAvailable = firstAvailable && firstAvailable.available;

    li.innerHTML = `
      <a href="/products/${product.handle}" class="cart-rv__card-img-link">
        <div class="cart-rv__card-img-wrap">
          ${imageUrl
            ? `<img src="${imageUrl}" alt="${product.title}" loading="lazy" class="cart-rv__card-img">`
            : '<div class="cart-rv__card-img cart-rv__card-img--placeholder"></div>'}
        </div>
      </a>
      <p class="cart-rv__card-title">
        <a href="/products/${product.handle}">${product.title}</a>
      </p>
      <p class="cart-rv__card-price">
        ${compareAt && compareAt > price
          ? `<span class="cart-rv__price-original">${formatMoney(compareAt)}</span> `
          : ''}
        <span class="cart-rv__price-final">${formatMoney(price)}</span>
      </p>
      ${variantHtml}
      <button class="cart-rv__add-btn" type="button"
        data-variant-id="${firstAvailable ? firstAvailable.id : ''}"
        ${!isAvailable ? 'disabled' : ''}>
        ${isAvailable ? STRINGS.add : STRINGS.soldOut}
      </button>
    `;

    const btn = li.querySelector('.cart-rv__add-btn');
    const select = li.querySelector('.cart-rv__select');

    if (select) {
      // Set initial to first available
      if (firstAvailable && firstAvailable.id !== defaultVariant.id) {
        select.value = firstAvailable.id;
      }
      select.addEventListener('change', () => {
        btn.dataset.variantId = select.value;
        const chosen = variants.find(v => String(v.id) === select.value);
        if (chosen) {
          btn.disabled = !chosen.available;
          btn.textContent = chosen.available ? STRINGS.add : STRINGS.soldOut;
        }
      });
    }

    btn.addEventListener('click', () => {
      const vid = parseInt(btn.dataset.variantId, 10);
      if (vid) addToCart(vid, btn);
    });

    return li;
  }

  function initCarousel(section) {
    const wrapper = section.querySelector('.cart-rv__track-wrapper');
    const prevBtn = section.querySelector('.cart-rv__arrow--prev');
    const nextBtn = section.querySelector('.cart-rv__arrow--next');
    if (!wrapper || !prevBtn || !nextBtn) return;

    function updateArrows() {
      const maxScroll = wrapper.scrollWidth - wrapper.clientWidth;
      prevBtn.disabled = wrapper.scrollLeft <= 2;
      nextBtn.disabled = maxScroll <= 0 || wrapper.scrollLeft >= maxScroll - 2;
      prevBtn.style.opacity = prevBtn.disabled ? '0.3' : '1';
      nextBtn.style.opacity = nextBtn.disabled ? '0.3' : '1';
    }

    prevBtn.addEventListener('click', () => {
      wrapper.scrollBy({ left: -(CARD_WIDTH + 12) * 2, behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', () => {
      wrapper.scrollBy({ left: (CARD_WIDTH + 12) * 2, behavior: 'smooth' });
    });
    wrapper.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  }

  let addonLoaded = false;

  async function loadAddonCollection() {
    if (addonLoaded) return;

    const section = document.getElementById('cart-addon-collection');
    if (!section) return;

    const track = document.getElementById('cart-addon-track');
    if (!track) return;

    try {
      const res = await fetch(`/collections/${COLLECTION_HANDLE}/products.json?limit=${MAX_PRODUCTS}`);
      if (!res.ok) return;

      const data = await res.json();
      const products = data.products || [];
      if (products.length === 0) return;

      products.forEach(product => {
        // Show all products — unavailable variants shown as "Épuisé"
        track.appendChild(buildCard(product));
      });

      section.style.display = 'block';
      initCarousel(section);
      addonLoaded = true;

    } catch (e) {
      console.warn('[cart-addon] Error loading collection:', e);
    }
  }

  function attachDrawerObserver() {
    const drawer = document.getElementById('drawer-cart');
    if (!drawer) return;

    // Load immediately if drawer is already visible
    if (drawer.classList.contains('drawer--visible') || drawer.classList.contains('is-open')) {
      loadAddonCollection();
    }

    new MutationObserver(() => {
      if (drawer.classList.contains('drawer--visible') || drawer.classList.contains('is-open')) {
        loadAddonCollection();
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  loadStrings();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachDrawerObserver);
  } else {
    attachDrawerObserver();
  }

  // Fallback: also try 1s after page load
  window.addEventListener('load', () => setTimeout(loadAddonCollection, 1000));

})();
